import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=cf028ce8&scoped=true"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"
import style0 from "./Match.vue?vue&type=style&index=0&id=cf028ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf028ce8",
  null
  
)

export default component.exports